module.exports = __webpack_public_path__ + "img/xiao.2c446547.svg";